import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const BELIEFS = [
  {
    q: "The Holy Bible",
    a: "We believe the Bible — Old and New Testaments — is the inspired, infallible Word of God and our final authority for faith, doctrine and Christian living (2 Timothy 3:16-17).",
  },
  {
    q: "The Trinity",
    a: "We believe in one God eternally existing in three persons — the Father, the Son (Jesus Christ), and the Holy Spirit (Matthew 28:19).",
  },
  {
    q: "The Lord Jesus Christ",
    a: "We believe Jesus is the eternal Son of God, conceived by the Holy Spirit, born of the virgin Mary, fully God and fully man, who died, rose again and is coming back in glory (John 1:1-14; 1 Corinthians 15:3-4).",
  },
  {
    q: "Salvation by grace through faith",
    a: "Salvation is received as a gift of God's grace through repentance and personal faith in Jesus Christ — not by works, lest anyone should boast (Ephesians 2:8-9).",
  },
  {
    q: "Water Baptism",
    a: "We believe in believer's baptism by full immersion as commanded by the Lord Jesus and a public declaration of faith (Matthew 28:19; Acts 2:38).",
  },
  {
    q: "Baptism in the Holy Spirit",
    a: "We believe in the Baptism in the Holy Spirit and the operation of His gifts in the life of every believer for witness, ministry and edification of the body (Acts 1:8; 1 Corinthians 12).",
  },
  {
    q: "Holiness & Sanctification",
    a: "We believe in a life of holiness — set apart unto God in heart, speech and conduct — empowered by the Holy Spirit (Hebrews 12:14; 1 Peter 1:15-16).",
  },
  {
    q: "Divine Healing",
    a: "We believe Jesus is the Healer; by His stripes we are healed in body, soul and spirit (Isaiah 53:5; James 5:14-16).",
  },
  {
    q: "The Second Coming of Christ",
    a: "We believe in the imminent, personal and visible return of the Lord Jesus Christ to gather His Church and judge the world in righteousness (1 Thessalonians 4:16-17; Revelation 22:12).",
  },
  {
    q: "The Church and Mission",
    a: "We believe the Church is the body of Christ, called to make disciples of all nations through the power of the Holy Spirit, until Jesus comes (Matthew 28:18-20).",
  },
];

export default function Beliefs() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/content/beliefs_page").then((r) => setC(r.data || {})).catch(() => {}); }, []);
  return (
    <div data-testid="beliefs-page" className="bg-[#050505] text-white">
      <section className="py-32 md:py-40 px-6 md:px-12 border-b border-white/10">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono-accent text-xs tracking-[0.3em] uppercase text-[#ff5c00] mb-4">{c.eyebrow || "What We Believe"}</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl uppercase font-bold tracking-tighter leading-[0.9]">
            {c.headline_lead || "Anchored in"} <span className="text-[#ff5c00]">{c.headline_accent || "truth"}</span>{c.headline_tail || "."}
          </h1>
          <p className="text-zinc-300 text-lg md:text-xl max-w-3xl mt-8">
            {c.intro_body || "Our doctrine flows from Scripture and aligns with the historic Pentecostal beliefs of RCCG worldwide. Here's what we stand on — without apology."}
          </p>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3" data-testid="beliefs-accordion">
            {BELIEFS.map((b, i) => (
              <AccordionItem
                key={b.q}
                value={`item-${i}`}
                data-testid={`belief-item-${i}`}
                className="bg-[#0f0f14] border border-white/10 rounded-sm px-6 hover:border-[#ff5c00]/40 transition-colors"
              >
                <AccordionTrigger className="font-display text-lg md:text-xl uppercase tracking-tight text-left hover:no-underline py-5">
                  <span className="flex items-center gap-4">
                    <span className="font-mono-accent text-xs text-[#ff5c00] w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {b.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-zinc-300 leading-relaxed pb-5 pl-12">
                  {b.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
